import script from "./button.vue?vue&type=script&setup=true&lang=js"
export * from "./button.vue?vue&type=script&setup=true&lang=js"

import "./button.vue?vue&type=style&index=0&id=0afb6328&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afb6328"]])

export default __exports__